// La clé correspond au type de la notification envoyé par le serveur afin de récupérer l'icon et le titre associé
export default {
  USER: {
    icon: '<i class="material-icons">&#xE7FE;</i>',
    title: 'Utilisateurs',
  },
  DAYS_OFF: {
    icon: '<i class="material-icons">&#xE065;</i>',
    title: 'Demande de congé',
  },
  DAILY_REPORT: {
    icon: '<i class="material-icons">&#xE065;</i>',
    title: 'Daily Report',
  },
  TASK: {
    icon: '<i class="material-icons">&#xe85d;</i>',
    title: 'Task',
  },
  ACTION_PERFORMED: {
    icon: '<i class="material-icons">&#xe862;</i>',
    title: 'Action Performed',
  },
  CONTRACT: {
    icon: '<i class="material-icons">&#xE065;</i>',
    title: 'Contrat',
  },

};
